import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { loginStaff, clearError } from '../../redux/slices/authSlice';
import './Login.css';

const Login = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const { loading, error } = useSelector((state) => state.auth);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const result = await dispatch(loginStaff({ email, password }));
    if (result.payload) {
      navigate('/');
    }
  };

  return (
    <div className="admin-login-container">
      <div className="login-card">
        <div className="login-header">
          <img
            src="https://mundotrabajos.es/images/brand/logo-mundotrabajos.png"
            alt="MundoTrabajos"
            className="login-logo"
            onError={(e) => { e.target.style.display = 'none'; }}
          />
          <h1>Backoffice</h1>
          <p>Solo para personal autorizado de MundoTrabajos</p>
        </div>

        {error && (
          <div className="alert alert-error" role="alert">
            {error}
            <button onClick={() => dispatch(clearError())} className="btn-close">&times;</button>
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label htmlFor="email">Correo corporativo</label>
            <input
              id="email"
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              disabled={loading}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Contraseña</label>
            <input
              id="password"
              type="password"
              name="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              disabled={loading}
              autoComplete="current-password"
            />
          </div>

          <button type="submit" disabled={loading} className="btn btn-primary btn-block">
            {loading ? 'Iniciando sesión...' : 'Entrar al panel'}
          </button>
        </form>

        <div className="login-footer">
          <a href="/admin?view=forgot">¿Olvidaste tu contraseña?</a>
          <a href="/">Volver a la web</a>
        </div>
      </div>
    </div>
  );
};

export default Login;
